import yearlyRecordSplit from "./operations/yearlyRecordSplit";
import type { CsvRow, DataOperationDefinition, OperationResult } from "./types";

export const OPERATION_REGISTRY: Record<string, DataOperationDefinition<any>> = {
  [yearlyRecordSplit.id]: yearlyRecordSplit,
};

export const OPERATION_LIST: DataOperationDefinition<any>[] = Object.values(OPERATION_REGISTRY);

export function getOperation(id: string | null | undefined): DataOperationDefinition<any> | null {
  if (!id) return null;
  return OPERATION_REGISTRY[id] ?? null;
}

export function applyOperation(id: string, rows: CsvRow[], args: any): OperationResult {
  const op = getOperation(id);
  if (!op) throw new Error(`Unknown data operation: ${id}`);
  const err = op.validateArgs(args);
  if (err) throw new Error(err);
  return op.apply(rows, args);
}
